import { Component, Inject } from "@angular/core";
import { VentanaFlotante } from "../models/VentanaFlotante";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import type { Colaborador as ColaboradorModel } from "../models/Colaborador";
import type { Tabla } from "../services/bd/Tablas/tablas.service";
import { isEmpty } from '../helpers/string';

@Component({
  selector: 'ral-tipo-llamada',
  templateUrl: './tipo-llamada.component.html',
  styleUrls: ['./tipo-llamada.component.scss']
})
export class TipoLlamadaComponent extends VentanaFlotante {
  protected tiposLlamadas: Tabla[];
  protected tipo = '';

  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: { tiposLlamadas: Tabla[] },
  )
  {
    super(dialogRef, data);
    this.tiposLlamadas = data.tiposLlamadas;
  }

  puedeGuardar(): boolean {
    return !isEmpty(this.tipo);
  }

  guardar(): void {
    this.dialogRef.close(this.tipo);
  }
}
